<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header :entity="$entitiesName.DocumentType"
                   :edit="edit"
                   :save="save"
                   :cancel="cancel"
                   :remove="remove">
        <h1 class="title">
          <breadcrumb location="/documenttypes"
                      text="Type de document"></breadcrumb>
          {{ documentType.name }}
        </h1>
      </page-header>

      <div class="panel infos">
        <div class="panel-heading has-background-primary">{{$t('common.information')}}</div>
        <div class="panel-block is-block no-border">
          <text-field :label="$t('common.name')"
                      v-model="documentType.name"
                      required></text-field>
          <text-field :label="$t('common.code')"
                      v-model="documentType.code" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'document-type',
  props: ['id'],
  data () {
    return {
      documentType: {},
    };
  },
  computed: {
    ...mapGetters({
      editMode: 'states/isEdition',
    }),
  },
  mounted () {
    this.fetchData();
  },
  methods: {
    fetchData () {
      axios.get(`/documenttype/${this.id}`).then((response) => {
        this.documentType = response.data;
        this.$store.dispatch('states/setEdition', false);
      });
    },
    edit () {
      this.$store.dispatch('states/setEdition', true);
    },
    cancel () {
      this.fetchData();
    },
    save () {
      return axios.put(`/documenttype/${this.id}`, this.documentType).then((response) => {
        if (response.data.success) {
          this.fetchData();
        }
      });
    },
    remove () {
      const self = this;
      return this.$awn.confirm(
        'Êtes-vous sûr de vouloir supprimer cet élément ?',
        () => axios.delete(`/documenttype/${self.id}`).then((response) => {
          if (response.data.success) {
            self.$router.replace('/documenttypes');
          }
        }),
      );
    },
  },
};
</script>

<style scoped>
</style>

